import { format } from 'date-fns';
import formatDateStringToObject from './formatDateStringToObject';
/**
 * Gives the current day of date string such as '23rd' or '1st'
 * @param {string} dateString
 */
const formatDisplayDay = (dateString) => {
    return format(formatDateStringToObject(dateString), 'do');
};
export default formatDisplayDay;
